
import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import { User } from "@/models/user";
import Vue from "vue";
import { CompanyDossierService } from "@/services/company-dossier-service";
import AppDossierUsersAddModal from "./DossierUsersAddModal.vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			addUsersModal: false,
			selectedRows: [] as User[]
		};
	},
	props: {
		value: {
			type: Object as () => Dossier,
			required: true
		},
		company: {
			type: Object as () => Company,
			required: true
		}
	},
	computed: {
		columns():any[] {
			return [
				{
					name: "Id",
					property: "id",
					width: "50px"
				},
				{
					name: "Username",
					property: "username",
					width: "200px"
				},
				{
					name: "Email",
					property: "email"
				}
			];
		},
		addDisabled():boolean {
			return this.value.users.length >= this.company.users.length;
		},
		deleteDisabled():boolean {
			return this.selectedRows.length == 0;
		},
		dropdownItems():ISelectItem<string>[] {
			if (this.selectedRows.length == 1){
				return [
					{
						text: "Create WinFakt! Offline token",
						value: "create-wf-offline-token"
					}
				];
			}
			return [];
		}
	},
	methods: {
		addClicked() {
			this.addUsersModal = true;
		},
		usersAdded(dossier:Dossier) {
			this.$emit("input", dossier);
		},
		async dropdownTrigger(action:string){
			if (action == "create-wf-offline-token"){
				if (this.selectedRows.length != 1){
					return;
				}
				let user = this.selectedRows[0];
				let token = await CompanyDossierService.createWfOfflineToken(this.company.id, this.value.id, user.id);
				await navigator.clipboard.writeText(token);
				this.$wf.notify("Token coppied to clipboard", "info", 3000, "info");
			}
		},
		async removeClicked() {
			let confirm = await this.$wf.confirm(`Are you sure you want to remove ${this.selectedRows.length} users from this dossier?`, "yes", "no");
			if  (confirm) {
				let res = await CompanyDossierService.removeUsers(this.value, this.selectedRows);
				this.$emit("input", res);
			}
		}
	},
	components: {
		AppDossierUsersAddModal
	}
});
